<template>
  <transition name="fade">
    <div v-if="showed" id="confirm" @mousedown="close($event)">
      <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                <div class="title">Confirm</div>
              </h5>
            </div>
            <div class="modal-body">
              <label>{{ message }}</label>
            </div>
            <div class="modal-footer">
              <b-button type="submit" variant="primary" class="mx-auto mt-4" @click="confirmed">Ok</b-button>
              <b-button type="submit" variant="primary" class="mx-auto mt-4" @click="close(true)">Cancel</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import {events} from './events'

  export default {
    name: 'confirm',
    data() {
      return {
        showed: false,
        message: null,
        callback: null,
      }
    },
    methods: {
      show(data) {
        this.showed = true
        this.message = data.message
        this.callback = data.callback
      },
      close(event) {
        if (event === true || event.target.id === 'confirm')
          this.clear()
      },
      confirmed() {
        if (this.callback)
          this.callback(true)
        this.clear()
      },
      clear() {
        this.showed = false
        this.message = ''
        this.callback = false
      }
    },
    mounted() {
      if (!document) return
      events.$on('show', this.show)
      events.$on('close', () => {
        this.close(true)
      })
    },
  }
</script>